import { Controller } from "stimulus"
import ApexCharts from "apexcharts"

export default class extends Controller {
  connect() {
    const config = this.readConfig()
    if (!config) return

    this.chart = new ApexCharts(this.canvasElement(), this.buildOptions(config))
    this.chart.render()
  }

  disconnect() {
    if (this.chart) {
      this.chart.destroy()
      this.chart = null
    }
  }

  readConfig() {
    const raw = this.element.dataset.chatChartConfigValue
    if (!raw) return null

    try {
      return JSON.parse(raw)
    } catch (_error) {
      return null
    }
  }

  downloadPng() {
    if (!this.chart) return

    this.chart.dataURI().then(({ imgURI }) => {
      const link = document.createElement("a")
      link.href = imgURI
      link.download = this.filename()
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    })
  }

  canvasElement() {
    return this.element.querySelector(".chat-chart-canvas")
  }

  filename() {
    return this.element.dataset.chatChartFilename || "chat-chart.png"
  }

  buildOptions(config) {
    const chartType = config.type === "line" ? "line" : "bar"
    const sharedTooltip = !!config.stacked || chartType === "line"

    return {
      chart: {
        type: chartType,
        height: 280,
        stacked: !!config.stacked,
        toolbar: { show: false }
      },
      series: config.series || [],
      xaxis: {
        categories: config.categories || [],
        title: { text: config.x_axis_title || "" }
      },
      yaxis: {
        title: { text: config.y_axis_title || "" }
      },
      dataLabels: {
        enabled: false
      },
      stroke: {
        curve: chartType === "line" ? "smooth" : "straight",
        width: chartType === "line" ? 3 : 1
      },
      plotOptions: {
        bar: {
          horizontal: false,
          columnWidth: "55%"
        }
      },
      legend: {
        show: (config.series || []).length > 1
      },
      tooltip: {
        shared: sharedTooltip,
        intersect: !sharedTooltip
      }
    }
  }
}
